import {GeneRefs} from "../types/Types";

export const getAllianceUrlForEntrez = (
  entrezID: number,
  geneRefs?: Record<number, GeneRefs>
): string | null => {
  if (!geneRefs) return null;
  const hgncId = geneRefs[entrezID]?.h;
  return hgncId ? `https://www.alliancegenome.org/gene/${hgncId}` : null;
};

export const openAllianceGenome = (
  entrezID: number,
  geneRefs?: Record<number, GeneRefs>,
  target: string = "_blank"
): boolean => {
  const url = getAllianceUrlForEntrez(entrezID, geneRefs);
  if (!url) return false;
  window.open(url, target);
  return true;
};

export const openAllianceGenomeDirect = (hgncId: string | undefined, target: string = "_blank") => {
  if (!hgncId) return;
  window.open(`https://www.alliancegenome.org/gene/${hgncId}`, target);
};

export const openGeneCards = (entrezID: number, target: string = "_blank") => {
  window.open(`https://www.genecards.org/cgi-bin/carddisp.pl?gene=${entrezID}`, target);
};

export const openDepMap = (symbol: string, target: string = "_blank") => {
  window.open(  `https://depmap.org/portal/gene/${symbol}?tab=overview`, target);
};

export const openGoogle = (query: string, target: string = "_blank") => {
  window.open(`https://www.google.com/search?q=${query}`, target);
}

export const openUniProt = (symbol: string, target: string = "_blank") => {
  const newWindow = window.open("", target);
  if (!newWindow) return; // popup blocked

  newWindow.document.write(`
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <title>UniProt Lookup</title>
        <style>
          body {
            font-family: sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            margin: 0;
          }
        </style>
      </head>
      <body>
        Looking up UniProt entry for ${symbol}...
      </body>
    </html>
  `);
  newWindow.document.close();

  fetch(
    `https://rest.uniprot.org/uniprotkb/search?query=gene:${symbol}+AND+organism_id:9606+AND+reviewed:true&size=1&fields=accession`
  ).then(res => res.json()
  ).then(data => {
    if (!data.results.length || !data.results[0].primaryAccession) {
      newWindow.location.href = `https://www.uniprot.org/uniprotkb?query=gene:${symbol}+AND+organism_id:9606`;
      return;
    }

    /* We found accession, open direct link */
    newWindow.location.href = `https://www.uniprot.org/uniprotkb/${data.results[0].primaryAccession}`;


  }).catch(() => {
    /* No accession found or other problems, open search page */
    newWindow.location.href = `https://www.uniprot.org/uniprotkb?query=gene:${symbol}+AND+organism_id:9606`;
  });
};

export const openOverlayScreen = (screen: string, target: string = "_blank") => {
  const url = `/human/overlay?s=${screen}`;
  window.open(url, target);
};
